import PropTypes from "prop-types"
import RegistrationsPropTypes from "utils/prop_types"
import DateTimeContainer from "./DateTimeContainer"
import AddDateTimeButton from "./AddDateTimeButton"

const EventTimeContainer = ({
  eventTimes,
  visibleEventTimes,
  mobileBrowser,
  twentyFourHourTime,
  onChange,
  handleAddEventTime
}) => {
  const visibleEvenPosition = eventTime => {
    const position = visibleEventTimes.indexOf(vet => vet.key === eventTime.key) + 1
    return position % 2 === 0
  }

  return (
    <div className="event-times-container">
      <div className="collection-js">
        {eventTimes.length > 0 &&
          eventTimes.map(eventTime => {
            return (
              <DateTimeContainer
                eventTime={eventTime}
                canDeleteAllEventTimes={true}
                visibleEvenPosition={visibleEvenPosition(eventTime)}
                onlyEventTime={visibleEventTimes.length === 1}
                mobileBrowser={mobileBrowser}
                onChange={onChange}
                twentyFourHourTime={twentyFourHourTime}
                key={`list-${eventTime.key}`}
              />
            )
          })}
        <AddDateTimeButton handleAddition={handleAddEventTime} />
      </div>
      {eventTimes.length > 25 && (
        <div className="info-alert alert">
          On Church Center, only the next 25 dates and times are shown.
        </div>
      )}
    </div>
  )
}

EventTimeContainer.propTypes = {
  eventTimes: PropTypes.arrayOf(RegistrationsPropTypes.EventTime),
  visibleEventTimes: PropTypes.arrayOf(RegistrationsPropTypes.EventTime),
  mobileBrowser: PropTypes.bool.isRequired,
  twentyFourHourTime: PropTypes.bool.isRequired,
  onChange: PropTypes.func,
  handleAddEventTime: PropTypes.func
}

export default EventTimeContainer
